import React from "react";

interface CheckboxComponentProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  customCss?: string;
}

const CheckboxComponent: React.FC<CheckboxComponentProps> = ({
  checked,
  onChange,
  label,
  customCss = "",
  ...props
}) => {
  return (
    <label className={`flex items-center gap-2 cursor-pointer ${customCss}`}>
      <input
        type="checkbox"
        className="accent-blue-500 h-5 w-5 cursor-pointer"
        checked={checked}
        onChange={onChange}
        {...props}
      />

      {label && <span className="text-sm">{label}</span>}
    </label>
  );
};

export default CheckboxComponent;
